import { defineComponent as _defineComponent } from 'vue'
import IconClose from '@/components/icons/IconClose.vue';
import IconBarcode from '@/components/icons/IconBarcode.vue';
import { ref } from 'vue';

interface FormValue {
    promocode: string | null;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'PromocodeModal',
  emits: ["handleSavePromocode", "handleCloseModal"],
  setup(__props, { emit }: { emit: ({
    (e: 'handleSavePromocode', val: string | null): void;
    (e: 'handleCloseModal'): void;
}), expose: any, slots: any, attrs: any }) {



const formValues = ref({
    promocode: null,
} as FormValue);

function handleSubmit(val: FormValue) {
    emit('handleSavePromocode', val.promocode);
    handleClose();
}

function handleClose() {
    emit('handleCloseModal');
}

return { __sfc: true,emit, formValues, handleSubmit, handleClose, IconClose, IconBarcode }
}

})